import { PriceIncludingWildMembership } from '@/shared/types/prices';
import { getPriceByType } from '@/features/games/shared/helpers/get-price-by-type';

export function getEffectivePromotionalPrices(
  promotionalPrices: PriceIncludingWildMembership[] | undefined,
  currentPriceValue: number | undefined,
): PriceIncludingWildMembership[] | undefined {
  if (!promotionalPrices?.length) return undefined;
  if (typeof currentPriceValue !== 'number' || currentPriceValue <= 0) return undefined;

  const promotionalCurrentPrice = getPriceByType(promotionalPrices, 'current');
  if (!promotionalCurrentPrice || promotionalCurrentPrice.value <= 0) return undefined;

  return promotionalCurrentPrice.value < currentPriceValue ? promotionalPrices : undefined;
}
